export const SITE = {
  coach: "Diego Taira",
  brand: "WEALTH X COACH",
  email: "diego@wealth-angels.com",
  whatsapp: "https://wa.me/6500000000",
  // Stripe payment link provided by Diego
  stripeLink: "https://buy.stripe.com/14A14o3TveUv1n4b9Yebu06",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
